import BaseApiService from './BaseApiService'

export interface IngestionSource {
  ingestionSourceId: string
  name: string
  sourceType: string
  isActive: boolean
  createdAt: string
}

export interface CreateIngestionSourceRequest {
  name: string
  sourceType: string
  credentials: Record<string, unknown>
}

export interface UpdateIngestionSourceRequest {
  name: string
  credentials: Record<string, unknown>
  isActive?: boolean
}

class IngestionApiService extends BaseApiService {
  list(): Promise<IngestionSource[]> {
    return this.post('/v1/ingestion/sources/list')
  }

  create(req: CreateIngestionSourceRequest): Promise<{ ingestionSourceId: string }> {
    return this.post('/v1/ingestion/sources/create', req)
  }

  update(sourceId: string, req: UpdateIngestionSourceRequest): Promise<void> {
    return this.post(`/v1/ingestion/sources/${sourceId}/update`, req)
  }

  delete(sourceId: string): Promise<void> {
    return this.post(`/v1/ingestion/sources/${sourceId}/delete`)
  }

  fetchAndRender(
    sourceId: string,
    opts: {
      templateVersionId: string
      query: string
      recordId?: string
      rowMode?: 'first' | 'array'
      outputFormat?: string
      onMissing?: string
      transform?: Record<string, unknown>
    }
  ): Promise<Blob> {
    return this.request<Blob>(
      'POST',
      `/v1/ingestion/sources/${sourceId}/fetch-and-render`,
      opts,
      true
    )
  }
}

export const ingestionApiService = new IngestionApiService()
